import React from 'react';
import { Link } from 'react-router-dom';
import {
    AppBar,
    Toolbar,
    IconButton,
    Button,
    Tooltip,
    Container,
    Stack
} from '@mui/material';
import { EventNote, ExitToApp } from '@mui/icons-material';

import './navbar.scss';
import { PRISPEK } from '../../assets';
import { Theme } from '../../config';
import { useAuth } from '../../context';

export interface NavbarProps {
    landing?: boolean;
    about?: boolean;
    services?: boolean;
    blog?: boolean;
    contact?: boolean;
    login?: boolean;
    satrix?: boolean;
    view?: boolean;
    policies?: boolean;
    drawer?: boolean;
    reset?: any;
    lightYellow?: string;
    addBlog?: boolean;
}

export const AdminNavbar: React.FC<NavbarProps> = React.memo(
    ({ view, policies, addBlog }) => {
        const { session, logout } = useAuth();
        return (
            <>
                <AppBar
                    position='fixed'
                    className='navbar'
                    style={{
                        background: 'rgb(277, 277, 277)',
                        zIndex: 10
                    }}
                    elevation={0}
                >
                    <Container maxWidth='xl'>
                        <Stack direction='row' justifyContent='space-between'>
                            <Toolbar>
                                <Link to='/' className='navbar__logo'>
                                    <img src={PRISPEK} alt='Prispek Logo' />
                                </Link>
                            </Toolbar>
                            <Toolbar>
                                {session.Role !== 2 && (
                                    <Link to='/members/view'>
                                        <Button
                                            variant='text'
                                            className='navbar__link'
                                            sx={{
                                                color: view ? Theme.primary : '#111'
                                            }}
                                            startIcon={<EventNote />}
                                        >
                                            View Members
                                        </Button>
                                    </Link>
                                )}
                                {/* {session.Role !== 2 && (
                                    <Link to='/blogs/add'>
                                        <Button
                                            variant='text'
                                            className='navbar__link'
                                            sx={{
                                                color: addBlog
                                                    ? Theme.primary
                                                    : '#111'
                                            }}
                                            startIcon={<Add />}
                                        >
                                            Blog
                                        </Button>
                                    </Link>
                                )} */}
                                <Link
                                    to={
                                        session.Role === 2
                                            ? '/policies'
                                            : '/policies/admin'
                                    }
                                >
                                    <Button
                                        variant='text'
                                        className='navbar__link'
                                        sx={{
                                            color: policies ? Theme.primary : '#111'
                                        }}
                                        startIcon={<EventNote />}
                                    >
                                        Policies
                                    </Button>
                                </Link>
                                <Link to='/login'>
                                    <Tooltip title='Logout' arrow>
                                        <IconButton
                                            className='navbar__link key'
                                            style={{
                                                background: Theme.lightYellow,
                                                color: 'black'
                                            }}
                                            onClick={logout}
                                        >
                                            <ExitToApp />
                                        </IconButton>
                                    </Tooltip>
                                </Link>
                            </Toolbar>
                        </Stack>
                    </Container>
                </AppBar>
            </>
        );
    }
);
